import { useTranslation } from "react-i18next";
import { useState, useRef } from "react";
import "../styles/ProjectsSection.css";

import imgBranding   from "../assets/services/branding.jpeg";
import imgTrafego    from "../assets/services/trafego.jpg";
import imgRedes      from "../assets/services/redes.jpeg";
import imgWebsite    from "../assets/services/ecommerce.jpg";
import imgInfluencia from "../assets/services/mkt.jpeg";
import imgEventos    from "../assets/services/eventos.jpeg";

const IMAGES = [imgBranding, imgTrafego, imgRedes, imgEventos, imgInfluencia, imgWebsite];

function ServiceCard({ item, onClick }) {
  const cardRef = useRef(null);

  const handleCardMove = (e) => {
    const card = cardRef.current;
    const rect = card.getBoundingClientRect();
    card.style.setProperty("--mouse-x", `${e.clientX - rect.left}px`);
    card.style.setProperty("--mouse-y", `${e.clientY - rect.top}px`);
  };

  return (
    <article
      ref={cardRef}
      className="service-card"
      onMouseMove={handleCardMove}
      onClick={() => onClick(item)}
    >
      <div className="service-card-img-wrapper">
        <img src={item.image} alt={item.title} loading="lazy" />
      </div>
      <footer className="service-card-info">
        <h3 className="service-card-title">{item.title}</h3>
        <p className="service-card-tagline">{item.handle}</p>
        <div className="service-card-subtitle">
          {item.subtitle.split(" • ").map((tag, i) => (
            <span key={i} className="service-card-pill">{tag}</span>
          ))}
        </div>
      </footer>
    </article>
  );
}

function ServiceModal({ item, onClose }) {
  const { t } = useTranslation("common");
  const handleKey = (e) => { if (e.key === "Escape") onClose(); };

  return (
    <div
      className="service-modal-overlay"
      onClick={onClose}
      onKeyDown={handleKey}
    >
      <div className="service-modal" onClick={(e) => e.stopPropagation()}>
        <button className="service-modal-close" onClick={onClose} aria-label={t("aria.close")}>×</button>
        <div className="service-modal-img-wrapper">
          <img src={item.image} alt={item.title} />
        </div>
        <div className="service-modal-body">
          <h2 className="service-modal-title">{item.title}</h2>
          <div className="service-modal-tags">
            {item.subtitle.split(" • ").map((tag, i) => (
              <span key={i} className="service-modal-tag-pill">{tag}</span>
            ))}
          </div>
          <p className="service-modal-description">{item.description}</p>
          <a href="/contactos" className="service-modal-cta" onClick={onClose}>
            <span>{t("contactUs")}</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default function ProjectsSection() {
  const { t } = useTranslation("services");
  const [selectedItem, setSelectedItem] = useState(null);

  const rawItems = t("items", { returnObjects: true });
  const items = rawItems.map((item, i) => ({ ...item, image: IMAGES[i] }));

  return (
    <section className="projects-section">
      <div className="projects-container">
        <header className="projects-header">
          <h2 className="projects-title">{t("title")}</h2>
          <p className="projects-subtitle">{t("subtitle")}</p>
        </header>

        <div className="service-grid">
          {items.map((item, i) => (
            <ServiceCard key={i} item={item} onClick={setSelectedItem} />
          ))}
        </div>
      </div>

      {selectedItem && (
        <ServiceModal item={selectedItem} onClose={() => setSelectedItem(null)} />
      )}
    </section>
  );
}
